import React, { useEffect } from "react";
import { Segment, Tab } from "semantic-ui-react";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { useParams } from "react-router-dom";
import ActionHistory from "./ActionHistory";
import GraphicRepresentation from "./GraphicRepresentation";
import XML from "./XML";
import { sectionHome } from "../../../app/util/breadcrumbOptions";
import General from "./General";
import NotificationHistory from "./NotificationHistory";

const DashboardPayroll: React.FC = () => {
  const { id, tab } = useParams<{ id: string; tab?: string }>();

  useEffect(() => {
    // Aquí se puede cargar el detalle de la nómina si es necesario
    // Por ahora los componentes hijos cargarán sus propios datos
  }, [id]);

  const panes = [
    {
      menuItem: "Información General",
      render: () => (
        <Tab.Pane>
          <General id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Representación Gráfica",
      render: () => (
        <Tab.Pane>
          <GraphicRepresentation id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "XML",
      render: () => (
        <Tab.Pane>
          <XML id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Historial de Acciones",
      render: () => (
        <Tab.Pane>
          <ActionHistory id={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Historial de Notificaciones",
      render: () => (
        <Tab.Pane>
          <NotificationHistory id={id} />
        </Tab.Pane>
      ),
    },
  ];

  document.title = `Detalle Nómina`;
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Detalle Nómina"
        sections={sectionHome}
      />
      <Segment>
        <div className="configurationContent">
          <Tab defaultActiveIndex={tab ? parseInt(tab) : 0} panes={panes} />
        </div>
      </Segment>
    </div>
  );
};

export default DashboardPayroll;
